import React from 'react';
import { Props, FormValues } from './CreateNewAffordabilityForm.types';
import { Field, Form, Formik } from 'formik';
import { Fields } from 'modules/af_cm_ui_kit/components';

import styles from './CreateNewAffordabilityForm.module.scss';
import validationSchema from './utils/validationSchema';
import { Button } from 'lmc-ui-library';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';

const initialFormValues: FormValues = {
  caseNumber: '',
  name: '',
};

const CreateNewAffordabilityForm: React.FC<Props> = ({ onSubmit }) => {
  const handleSubmit = (values: FormValues) => {
    onSubmit(values);
  };

  return (
    <Formik initialValues={initialFormValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
      {() => {
        return (
          <Form>
            <Field component={Fields.Text} title="Name" name="name" />
            <Field
              component={Fields.Text}
              title="Case number (if known)"
              name="caseNumber"
              variant={VARIANTS_TYPES.CASE_NUMBER}
              extraContent={[
                {
                  position: 'bottom',
                  variant: 'normal',
                  content: 'A calculation reference will also be generated',
                },
              ]}
            />
            <div className={styles.controls}>
              <Button mode="secondary" borderVariant="rectangle" small type="submit">
                Create
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateNewAffordabilityForm;
